import React, { FC, useMemo } from 'react';
import { Button, Box, Typography, Link } from '@mui/material';
import { ProviderTileStyledComponentProps } from '../provider-tile-styled-component-props';
import { useStyles as useCommonStyles } from '../ProviderTile.styles';
import { useStyles } from './ProviderOutlinedTile.styles';
import classNames from 'classnames';

export const ProviderOutlinedTile: FC<ProviderTileStyledComponentProps> = ({
  provider,
  disabled,
  isConnected,
  onClick,
  onUnlinkClick,
}) => {
  const { classes: commonClasses } = useCommonStyles({ status: provider?.connectionStatus });
  const { classes } = useStyles({ status: provider?.connectionStatus });

  const icon = useMemo(
    () => (
      <Box className={classNames(commonClasses.icon, classes.icon)}>
        <img src={provider.providerIcon} alt={provider.platformName} />
      </Box>
    ),
    [classes.icon, commonClasses.icon, provider.platformName, provider.providerIcon]
  );

  const content = useMemo(() => {
    if (isConnected) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <Typography component="span" mr={1}>
            Connected
          </Typography>
          <Link onClick={onUnlinkClick} className={classes.unlink}>
            Unlink
          </Link>
        </Box>
      );
    }

    return <Typography component="span">Link {provider?.platformName} Account</Typography>;
  }, [classes.unlink, isConnected, onUnlinkClick, provider?.platformName]);

  const variant = useMemo(() => {
    return isConnected ? 'contained' : 'outlined';
  }, [isConnected]);

  return (
    <Button
      onClick={onClick}
      startIcon={icon}
      disabled={disabled}
      variant={variant}
      className={classes.root}
      size="large"
      fullWidth
    >
      {content}
    </Button>
  );
};
